export default __webpack_public_path__ + "static/media/marquise.e35ee4a3.svg";